<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Crear Torneo" />

    <CreateTournament />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue"; 
import CreateTournament from "@/components/Pages/Admin/Tournaments/view.vue";

export default defineComponent({
  name: "CreateTournamentPage",
  components: {
    PageTitle,
    CreateTournament,
  },
});
</script>
